import http from '../../../http-common';

export default function requestLoadTramos() {
    return http.get('/tramos');
}
